import { useState } from "react";
import { Button, Form, Modal, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import { updateLandlordSkipSteps } from "../context/functions/AdminFunction";

const SKIP_STEPS = [
  { value: "basic_info", label: "Basic Info" },
  { value: "kyc_onboarding", label: "ID Verification (KYC)" },
  { value: "required_documents", label: "Required Documents" },
  { value: "missing_document", label: "Missing Documents" },
  { value: "bank_onboarding", label: "Bank Onboarding" },
  { value: "guarantor_onboarding", label: "Guarantor Onboarding" },
];

const SkipStepsModal = ({ show, landlord, onHide, onSave }) => {
  const [selected, setSelected] = useState(landlord?.skip_steps || []);
  const [saving, setSaving] = useState(false);

  const handleToggle = (step) => {
    setSelected((current) =>
      current.includes(step)
        ? current.filter((item) => item !== step)
        : [...current, step],
    );
  };

  const handleSave = async () => {
    const previous = landlord?.skip_steps || [];
    const stepsToAdd = selected.filter((step) => !previous.includes(step));
    const stepsToRemove = previous.filter(
      (step) => !selected.includes(step),
    );

    if (stepsToAdd.length === 0 && stepsToRemove.length === 0) {
      onHide();
      return;
    }

    setSaving(true);
    try {
      if (stepsToAdd.length > 0) {
        await updateLandlordSkipSteps({
          landlord_id: landlord._id,
          action: "add",
          steps: stepsToAdd,
        });
      }
      if (stepsToRemove.length > 0) {
        await updateLandlordSkipSteps({
          landlord_id: landlord._id,
          action: "remove",
          steps: stepsToRemove,
        });
      }
      toast.success("Skip steps updated successfully");
      onSave?.();
      onHide();
    } catch (error) {
      console.log(error);
      toast.error(
        error?.response?.data?.errormsg ||
          error?.response?.data?.message ||
          "Error while updating skip steps",
      );
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      show={show}
      size="md"
      centered
      onHide={() => {
        if (!saving) onHide();
      }}
    >
      <Modal.Header closeButton className="landlord-modal-header">
        <Modal.Title className="fw-bold h5">
          Skip Steps
          {landlord?.fname_companyName
            ? ` - ${landlord.fname_companyName}`
            : ""}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="landlord-modal-body">
        <p className="text-muted small">
          Select the onboarding steps that should be skipped for this landlord's
          tenants.
        </p>
        {SKIP_STEPS.map((step) => (
          <Form.Check
            key={step.value}
            id={`skip-step-${step.value}`}
            type="checkbox"
            checked={selected.includes(step.value)}
            onChange={() => handleToggle(step.value)}
            label={step.label}
            className="mb-2"
          />
        ))}
      </Modal.Body>
      <Modal.Footer className="border-0">
        <Button
          variant="outline-secondary"
          className="landlord-action-btn"
          disabled={saving}
          onClick={onHide}
        >
          Cancel
        </Button>
        <Button
          className="landlord-btn-apply"
          disabled={saving}
          onClick={handleSave}
        >
          {saving ? (
            <>
              <Spinner size="sm" animation="border" className="me-2" />
              Saving...
            </>
          ) : (
            "Save"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SkipStepsModal;
